export const NRF93 = ({ ...props }) => (
	<svg
		version="1.1"
		viewBox="0 0 362.21 362.20999"
		width="362.20999"
		height="362.20999"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<defs>
			<linearGradient
				id="linear-gradient"
				x1="118.11"
				y1="24.6"
				x2="259.92001"
				y2="270.22"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stop-color="#d8690a" />
				<stop offset=".18" stop-color="#e27a20" />
				<stop offset=".47" stop-color="#f79b4d" />
				<stop offset=".6" stop-color="#f29343" />
				<stop offset=".8" stop-color="#e68029" />
				<stop offset="1" stop-color="#d8690a" />
			</linearGradient>
		</defs>
		<g transform="translate(8.6505144e-4,38.734996)">
			<g>
				<path
					style="fill:#fff"
					d="m 31.47,38.44 h 10.2 v 5.1 c 2.35,-3.02 5.37,-5.77 10.53,-5.77 7.72,0 12.21,5.1 12.21,13.35 V 74.39 H 54.22 V 54.34 c 0,-4.83 -2.29,-7.32 -6.18,-7.32 -3.89,0 -6.37,2.49 -6.37,7.32 V 74.39 H 31.47 V 38.43 Z"
				/>
				<path
					style="fill:#fff"
					d="m 74.36,27.44 h 21.47 c 5.97,0 10.6,1.68 13.68,4.76 2.62,2.62 4.03,6.31 4.03,10.74 v 0.13 c 0,7.58 -4.09,12.34 -10.06,14.56 L 114.95,74.4 H 102.87 L 92.8,59.38 H 84.69 V 74.4 H 74.36 Z m 20.79,22.81 c 5.03,0 7.91,-2.68 7.91,-6.64 v -0.13 c 0,-4.43 -3.08,-6.71 -8.12,-6.71 H 84.68 v 13.49 h 10.46 z"
				/>
				<path
					style="fill:#fff"
					d="m 122.89,27.44 h 35.75 v 9.39 h -25.42 v 10 h 22.4 v 9.39 h -22.4 V 74.4 h -10.33 z"
				/>
			</g>
			<path
				d="m 150.08,157.77 -38.26,94.9 H 56.61 l 36.31,-85.93 c -4.31,1.87 -7.04,2.21 -10.53,2.44 -27.5,1.87 -60.61,-19.29 -63.65,-63.84 -0.6,-8.84 0.03,-16.97 1.74,-24.38 h 49.07 c 0,6.45 0.16,13.39 0.16,22.64 0,17.36 11.93,22.22 21.73,22.22 9.8,0 22.2,-4.86 22.2,-22.22 V 80.96 h 49.75 c 1.01,4.44 1.85,9.15 2.08,14.17 0.99,19.62 -4.52,35.87 -15.39,62.64 z M 306.6,134.41 c 0,0 -11.99,-6.96 -19.23,-9.16 l 48.76,-57.63 h -65.26 l -44.72,52.55 c 0,0 0.13,37.93 0.34,37.98 h 30.09 c 15.4,0 24.06,14.63 24.06,28.24 0,16.14 -9.5,24.06 -23.11,24.06 -13.61,0 -23.11,-7.91 -23.11,-23.74 H 182.5 c 0,50.65 37.67,70.59 75.02,70.59 39.57,0 75.02,-22.16 75.02,-69.33 0,-26.91 -13.61,-45.02 -25.96,-53.57 z"
				style="fill:url(#linear-gradient)"
			/>
			<g>
				<path
					style="fill:#fff"
					d="m 184.82,55.8 4.22,-5.06 c 2.92,2.42 5.99,3.95 9.7,3.95 2.92,0 4.69,-1.16 4.69,-3.06 v -0.09 c 0,-1.81 -1.12,-2.74 -6.55,-4.14 -6.55,-1.67 -10.77,-3.47 -10.77,-9.93 v -0.09 c 0,-5.9 4.74,-9.79 11.37,-9.79 4.73,0 8.77,1.49 12.07,4.13 l -3.71,5.38 c -2.88,-1.99 -5.71,-3.2 -8.45,-3.2 -2.74,0 -4.18,1.25 -4.18,2.83 v 0.09 c 0,2.14 1.39,2.83 7,4.28 6.59,1.71 10.31,4.09 10.31,9.74 v 0.1 c 0,6.45 -4.92,10.06 -11.93,10.06 -4.92,0 -9.88,-1.71 -13.78,-5.2 z"
				/>
				<path
					style="fill:#fff"
					d="m 215.13,28.04 h 24.5 v 6.37 h -17.4 V 41 h 15.31 v 6.36 h -15.31 v 6.82 h 17.63 v 6.36 h -24.74 v -32.5 z"
				/>
				<path
					style="fill:#fff"
					d="m 244.61,28.04 h 14.85 c 4.13,0 7.33,1.17 9.47,3.3 1.81,1.81 2.78,4.36 2.78,7.43 v 0.09 c 0,5.24 -2.83,8.54 -6.96,10.08 l 7.94,11.6 h -8.35 l -6.97,-10.39 h -5.61 v 10.39 h -7.15 z m 14.38,15.79 c 3.48,0 5.48,-1.86 5.48,-4.6 v -0.1 c 0,-3.06 -2.13,-4.64 -5.62,-4.64 h -7.1 v 9.33 h 7.24 z"
				/>
				<path style="fill:#fff" d="m 276.86,28.04 h 7.15 v 32.5 h -7.15 z" />
				<path
					style="fill:#fff"
					d="m 290.51,28.04 h 24.51 v 6.37 h -17.4 V 41 h 15.31 v 6.36 h -15.31 v 6.82 h 17.64 v 6.36 h -24.74 v -32.5 z"
				/>
				<path
					style="fill:#fff"
					d="m 317.76,55.9 4.26,-5.1 c 2.95,2.44 6.04,3.98 9.78,3.98 2.95,0 4.73,-1.18 4.73,-3.09 V 51.6 c 0,-1.83 -1.12,-2.77 -6.6,-4.18 -6.6,-1.68 -10.86,-3.5 -10.86,-10.01 v -0.09 c 0,-5.95 4.77,-9.88 11.47,-9.88 4.77,0 8.84,1.5 12.17,4.16 l -3.74,5.43 c -2.91,-2.01 -5.76,-3.22 -8.52,-3.22 -2.76,0 -4.22,1.26 -4.22,2.85 v 0.09 c 0,2.16 1.4,2.86 7.07,4.31 6.64,1.73 10.39,4.12 10.39,9.82 v 0.1 c 0,6.51 -4.97,10.15 -12.03,10.15 -4.96,0 -9.97,-1.73 -13.9,-5.24 z"
				/>
			</g>
		</g>
	</svg>
)
